import { Alpine } from "./main.alpinejs.js";
// Store variables
import "./stores/oneTrustStore.js";
import "./stores/sectionIdStore.js";
import "./stores/translationStore.js";
import "./stores/modalStore.js";

import siteConfig from "./modules/siteConfig";

/* 
Note: When adding an async component, place it inside the x-data directory.  
Always use absolute paths, since this file is also used in expressions-docs.  
*/
const templateBaseUrl = `${siteConfig.context}/.resources/sanofi-lm-templates/themes/templates/src/js`;

// Global
Alpine.asyncData("advancedSearch", () => import(`${templateBaseUrl}/x-data/advancedSearch/index.js`));
Alpine.asyncData("app", () => import(`${templateBaseUrl}/x-data/app/index.js`));
Alpine.asyncData("dateTime", () => import(`${templateBaseUrl}/x-data/dateTime/index.js`));
Alpine.asyncData("docCheck", () => import(`${templateBaseUrl}/x-data/docCheck/index.js`));
Alpine.asyncData("eventDetails", () => import(`${templateBaseUrl}/x-data/eventDetails/index.js`));
Alpine.asyncData("eventListing", () => import(`${templateBaseUrl}/x-data/eventListing/index.js`));
Alpine.asyncData("exitModal", () => import(`${templateBaseUrl}/x-data/exitModal/index.js`));
Alpine.asyncData("formComponent", () => import(`${templateBaseUrl}/x-data/formComponent/index.js`));
Alpine.asyncData("geolocation", () => import(`${templateBaseUrl}/x-data/geolocation/index.js`));
Alpine.asyncData("glossary", () => import(`${templateBaseUrl}/x-data/glossary/index.js`));
Alpine.asyncData("isi", () => import(`${templateBaseUrl}/x-data/isi/index.js`));
Alpine.asyncData("listingFilters", () => import(`${templateBaseUrl}/x-data/listingFilters/index.js`));
Alpine.asyncData("listingFiltersV2", () => import(`${templateBaseUrl}/x-data/listingFiltersV2/index.js`));
Alpine.asyncData("locator", () => import(`${templateBaseUrl}/x-data/locator/index.js`));
Alpine.asyncData("loginPicker", () => import(`${templateBaseUrl}/x-data/loginPicker/index.js`));
Alpine.asyncData("mediaPlaylist", () => import(`${templateBaseUrl}/x-data/mediaPlaylist/index.js`));
Alpine.asyncData("navSearchPanel", () => import(`${templateBaseUrl}/x-data/navSearchPanel/index.js`));
Alpine.asyncData("orderCenter", () => import(`${templateBaseUrl}/x-data/orderCenter/index.js`));
Alpine.asyncData("pageMenuLink", () => import(`${templateBaseUrl}/x-data/pageMenuLink/index.js`));
Alpine.asyncData("paywall", () => import(`${templateBaseUrl}/x-data/paywall/index.js`));
Alpine.asyncData("quiz", () => import(`${templateBaseUrl}/x-data/quiz/index.js`));
Alpine.asyncData("skipToMain", () => import(`${templateBaseUrl}/x-data/skipToMain/index.js`));
Alpine.asyncData("talentLmsButton", () => import(`${templateBaseUrl}/x-data/talentLmsButton/index.js`));
Alpine.asyncData("video", () => import(`${templateBaseUrl}/x-data/video/index.js`));

// Auth
Alpine.asyncData("changePassword", () => import(`${templateBaseUrl}/x-data/auth/changePassword/index.js`));
Alpine.asyncData("consentAcknowledge", () => import(`${templateBaseUrl}/x-data/auth/consentAcknowledge/index.js`));
Alpine.asyncData("editProfile", () => import(`${templateBaseUrl}/x-data/auth/editProfile/index.js`));
Alpine.asyncData("emailVerification", () => import(`${templateBaseUrl}/x-data/auth/emailVerification/index.js`));
Alpine.asyncData("emailVerificationRequired", () => import(`${templateBaseUrl}/x-data/auth/emailVerificationRequired/index.js`));
Alpine.asyncData("forgotPassword", () => import(`${templateBaseUrl}/x-data/auth/forgotPassword/index.js`));
Alpine.asyncData("incompleteProfile", () => import(`${templateBaseUrl}/x-data/auth/incompleteProfile/index.js`));
Alpine.asyncData("login", () => import(`${templateBaseUrl}/x-data/auth/login/index.js`));
Alpine.asyncData("loginNoAuth", () => import(`${templateBaseUrl}/x-data/auth/loginNoAuth/index.js`));
Alpine.asyncData("newsletter", () => import(`${templateBaseUrl}/x-data/auth/newsletter/index.js`));
Alpine.asyncData("profile", () => import(`${templateBaseUrl}/x-data/auth/profile/index.js`));
Alpine.asyncData("registration", () => import(`${templateBaseUrl}/x-data/auth/registration/index.js`));
Alpine.asyncData("resetPassword", () => import(`${templateBaseUrl}/x-data/auth/resetPassword/index.js`));
Alpine.asyncData("unsubscribe", () => import(`${templateBaseUrl}/x-data/auth/unsubscribe/index.js`));

// Decom
Alpine.asyncData("inventory", () => import(`./x-data/decom/inventory/index.js`));

// Uikit x-data
Alpine.asyncAlias(`${siteConfig.context}/.resources/sanofi-lm-uikit/themes/uikit/dist/js/x-data/[name]/index.min.js`);